var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11V6Z",
    stroke: "#FB7401",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 11.9193 18.8189 12.8295 18.4672 13.6788C18.1154 14.5281 17.5998 15.2997 16.9497 15.9497C16.2997 16.5998 15.5281 17.1154 14.6788 17.4672C13.8295 17.8189 12.9193 18 12 18M12 18C11.0807 18 10.1705 17.8189 9.32122 17.4672C8.47194 17.1154 7.70026 16.5998 7.05025 15.9497C6.40024 15.2997 5.88463 14.5281 5.53284 13.6788C5.18106 12.8295 5 11.9193 5 11M12 18V21",
    stroke: "#FB7401",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/Mic.922d6033e6fc96bffae4a2c118dac43a.svg";
export { ForwardRef as ReactComponent };